export const enterpriseMessage = `Which of the following best describes your enterprise approach to analytics?`;

const enterpriseQ1 = `No enterprise perspective on data or analytics. Poorly integrated systems.`;

const enterpriseQ2 = `Islands of data, technology and expertise deliver local value`;

const enterpriseQ3 = `Process or business unit focus for analytics. Infrastructure for analytics beginning to 
coalesce.`;

const enterpriseQ4 = `Key data, technology and analysts are managed from an enterprise perspective`;

const enterpriseQ5 = `Key analytical resources focused on enterprise priorities and differentiation`;

export const enterpriseQuestions = [ enterpriseQ1, enterpriseQ2, enterpriseQ3, enterpriseQ4, enterpriseQ5 ];
export const enterpriseQuestionWeight = 0.16;
export const enterpriseQuestionsScore = [ 0.16, 0.32, 0.48, 0.64, 0.80 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/enterpriseData.ts